import React from 'react'
import { ButtonGroup as GroupBase } from 'reactstrap'
import Button from '../buttons/button'
import { ButtonGroupProps } from './types'

/**
 * Allows to render a button group with options for the grid
 * @author Alejandro Quiroz <alejandro.devop@gmail.com>
 * @version 1.0.0
 * @param param0
 * @returns
 */
const ButtonGroup: React.FC<ButtonGroupProps> = ({ buttons, size }) => {
    return (
        <>
            <GroupBase>
                {buttons.map(({ action, disabled, icon, iconSize, label, variant }, key) => (
                    <Button
                        disabled={disabled}
                        key={`button-group-${key}`}
                        icon={icon}
                        iconSize={iconSize}
                        onClick={action}
                        size={size}
                        variant={variant}
                    >
                        {label}
                    </Button>
                ))}
            </GroupBase>
        </>
    )
}

export default ButtonGroup
